import gql from "graphql-tag";
const MY_NOTIFICATIONS = gql`
	query (
		$where: NotificationResponseFilterInput
		$skip: Int
		$take: Int
		$order: [NotificationResponseSortInput!]
	) {
		myNotifications(
			where: $where
			skip: $skip
			take: $take
			order: $order
		) {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				notification {
					id
					entityName
					entityId
					text
					createdOn
					type {
						name
						icon
						color
					}
					contactId
				}
				isNew
			}
		}
		myNotViewedNotificationsCount
	}
`;
const NOTIFICATION_TYPES = gql`
	query notificationTypes(
		$skip: Int
		$take: Int
		$where: NotificationTypeFilterInput
		$order: [NotificationTypeSortInput!]
	) {
		notificationTypes(
			skip: $skip
			take: $take
			where: $where
			order: $order
		) {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				id
				name
				icon
				color
				group {
					name
				}
				templates {
					id
					subject
					body
					communicationChannel {
						id
					}
					culture {
						id
					}
				}
			}
		}
	}
`;
const NOTIFICATION_TYPES_FOR_EDIT = gql`
	query (
		$where: NotificationTypeFilterInput
		$order: [NotificationTypeSortInput!]
	) {
		notificationTypes(where: $where, order: $order) {
			id
			name
			description
			entityName
			icon
			color
			channels {
				id
			}
			templates {
				id
				code
				subject
				body
				communicationChannelId
				cultureId
			}
			groupId
		}
	}
`;
const MARK_NOTIFICATIONS_AS_VIEWED = gql`
	mutation {
		markAsViewed
	}
`;
const DELETE_MY_NOTIFICATION = gql`
	mutation ($input: BaseIdInput!) {
		deleteMyNotification(input: $input)
	}
`;
const EDIT_NOTIFICATION_TEMPLATES = gql`
	mutation ($input: NotificationTemplatesInput!) {
		editNotificationTemplates(input: $input)
	}
`;
const NOTIFICATION_TYPE_EDIT = gql`
	query ($id: UUID) {
		notificationTypes(where: { id: { eq: $id } }) {
			items {
				id
				name
				entityName
				description
				icon
				color
				channels {
					id
					name
				}
			}
		}
		notificationTemplates(
			order: { communicationChannel: { name: ASC } }
			where: { notificationTypeId: { eq: $id }, cultureId: { neq: null } }
		) {
			id
			code
			subject
			body
			communicationChannel {
				id
			}
			culture {
				id
			}
			isDeleted
		}
	}
`;
const ON_NOTIFICATION_ADDED = gql`
	subscription notifications($token: String!) {
		onNotificationAddedAsync(token: $token) {
			id
			entityName
			entityId
			text
			createdOn
			type {
				name
				icon
				color
			}
			contactId
		}
	}
`;
const ON_NOT_VIEWED_NOTIFICATION_COUNT_CHANGED = gql`
	subscription unreadNotificationsCount($token: String!) {
		onNotViewedNotificationCountChangedAsync(token: $token)
	}
`;
export {
  DELETE_MY_NOTIFICATION,
  EDIT_NOTIFICATION_TEMPLATES,
  MARK_NOTIFICATIONS_AS_VIEWED,
  MY_NOTIFICATIONS,
  NOTIFICATION_TYPES,
  NOTIFICATION_TYPES_FOR_EDIT,
  NOTIFICATION_TYPE_EDIT,
  ON_NOTIFICATION_ADDED,
  ON_NOT_VIEWED_NOTIFICATION_COUNT_CHANGED
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
